import { datefnsFormat } from '@/utils/dateFormat';
import store from '@/store';
import { OrdersInfo, OrderState, PayloadState } from '@/store/modules/orders';

/**
 * Push job detail data to GTM for analytics tracking for Job have progress
 * @param orderIds - Array of order IDs
 */
export const handleGTMEvent = async (orderIds: number[]) => {
    orderIds.forEach(async (orderId) => {
        triggerGTMEvent(orderId, false, false);
    });
};

export const triggerGTMEvent = async (orderId: any, isPublic: boolean, isBooster: boolean) => {
    if(isBooster) return;

    const careerID = store.getters['careerId/careerId'];

    if (!careerID) return;

    let ordersInfo: OrdersInfo = await store.getters['orders/getOrdersInfo'] ?? {} as OrdersInfo;
    let order: OrderState|undefined = (ordersInfo?.orders ?? []).find(order => order.orderId == orderId);

    if (!order) {
        const payloadState: PayloadState = {
            orderId,
            isPublic,
        }
        await store.dispatch('orders/receiveOrdersInfo', payloadState);
        ordersInfo = await store.getters['orders/getOrdersInfo'] ?? {} as OrdersInfo;
        order = (ordersInfo?.orders ?? []).find(_order => _order.orderId == orderId);
    }

    // Don't trigger GTM event for orders from the 'applied' or 'closed' page and for Approved event

    if(!order?.orderId) return;

    const isAiRecommended = Boolean(order?.isAiRecommended || order?.isNewRecommended);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'order_detail_view',
        job_id: orderId,
        career_id: careerID,
        view_datetime: datefnsFormat(new Date(), 'yyyy-MM-dd HH:mm:ss'),
        is_ai_recommend: isAiRecommended ? 1 : 0
    }); 
}
